import { createUseStyles } from 'react-jss';

import { ITheme, mediaQuery } from '../../../../styles';

const useStyles = createUseStyles<string, { showCopyAlert: boolean }, ITheme>(
  ({ breakpoints, colors }: ITheme) => ({
    button: {
      borderColor: 'transparent',
      padding: [8, 2],
      marginLeft: 'auto',
      '& > span': {
        gap: 4,
      },
      '&:hover': {
        backgroundColor: 'transparent',
        '& span': {
          color: '#787878',
          '& > i > svg > path': {
            fill: '#787878',
          },
        },
      },

      [mediaQuery(breakpoints.mobile)]: {
        padding: [6, 12],
      },
    },
    svgIcon: {
      '& > svg': {
        width: 20,
        height: 20,
        '& > path': {
          fill: colors.black,
        },
      },
    },

    modal: {
      margin: 'auto !important',
      width: 'fit-content !important',
      position: 'relative',
      padding: [32, 32, 40, 32],
      [mediaQuery(breakpoints.mobile)]: {
        padding: [30, 16, 32, 16],
        marginRight: 16,
        marginLeft: 16,
      },
    },
    modalClose: {
      position: 'absolute',
      top: 16,
      right: 16,

      '& > svg': {
        width: 30,
        height: 30,
        '& >path': {
          fill: 'rgb(128, 128, 128)',
        },
      },
      '&:hover': {
        cursor: 'pointer',
      },

      [mediaQuery(breakpoints.mobile)]: {
        top: 14,
        right: 14,
      },
    },

    copyTextAlert: {
      position: 'absolute',
      top: -80,
      visibility: ({ showCopyAlert }) => (showCopyAlert ? 'visible' : 'hidden'),
      width: 'calc(100% - 64px)',

      [mediaQuery(breakpoints.mobile)]: {
        width: 'calc(100% - 32px)',
      },
    },

    copyTextAlertContainer: {
      backgroundColor: 'transparent',
      width: 'fit-content',
      '&[data-reach-dialog-content]': {
        margin: '99px auto 0px',
        padding: [32, 46],
      },
      [mediaQuery(breakpoints.mobile)]: {
        width: 'auto',
        '&[data-reach-dialog-content]': {
          margin: '56px auto 0px',
          padding: [24, 16],
        },
      },
    },

    modalRoot: {
      display: 'flex',
    },
  }),
  {
    name: 'base-share-modal',
  },
);

export default useStyles;
